import {getUrlParam} from './common';

export const SUPPORTED_LANGUAGES = ['no', 'en', 'sv'];
export const DEFAULT_LANGUAGE = 'no';

const normalize = value => typeof value === 'string' ? value.trim().toLowerCase() : null;

const validate = value => SUPPORTED_LANGUAGES.includes(value) ? value : null;

// localStorage access throws SecurityError in sandboxed/storage-partitioned
// iframes (e.g. a SCORM package inside a third-party LMS).
const readStoredLanguage = () => {
  try {
    return localStorage.getItem('language');
  } catch {
    return null;
  }
};

/**
 * Resolves the active UI language.
 *
 * Precedence: `?lang=` URL param (waymaker appends it to the iframe URL) →
 * `localStorage['language']` (same-origin handoff from waymaker) → DEFAULT_LANGUAGE.
 * Any value outside SUPPORTED_LANGUAGES is ignored, so an unknown locale can never
 * strand the UI in a missing-translation state.
 */
export const getLanguage = () =>
  validate(normalize(getUrlParam('lang')))
  || validate(normalize(readStoredLanguage()))
  || DEFAULT_LANGUAGE;
